import { filterLanguage } from './filterLanguage';

export function getLanguageFromLocale(locale: string): string {
  if (locale && locale.length >= 2) {
    return filterLanguage(locale.substring(0, 2));
  }
  return null;
}
